import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloProvider } from 'react-apollo'
import ReactGA from 'react-ga'
// Local
import registerServiceWorker from './registerServiceWorker'
import App from './App'
// Styles
import './index.css'

ReactGA.initialize('UA-113139031-1', 'none')
const client = new ApolloClient({
  // By default, this client will send queries to the
  //  `/graphql` endpoint on the same host
  // Pass the configuration option { uri: YOUR_GRAPHQL_API_URL } to the `HttpLink` to connect
  // to a different host
  link: new HttpLink({
    uri: 'https://mv2il4uni1.execute-api.us-east-1.amazonaws.com/dev/graphql'
  }),
  cache: new InMemoryCache()
})

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js